/*
设备完好率
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import FormCore from "@/components/display/form/formCore";
// 业务接口
import CityDataFilterHoc from "@/hoc/form/cityDataHoc";
import "@/assets/stylus/data_analysis.styl";
import { Select, Affix, Tooltip, Form, Button, message, Radio } from "antd";
import { getCityList } from "@/fetch/fetchApi";
import { QuestionCircleOutlined } from "@ant-design/icons";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import StubIntactTop100 from "./stubIntactTop100";
import StationIntactTop10 from "./stationIntactTop10";
import StubDay from "./stubDay";
import StubMonth from "./stubMonth";
import ExportJsonExcel from 'js-export-excel';
const FormItem = Form.Item;

const { Option } = Select;
function getMonthFinalDay(year,month){
  var day='';
  if(year==null || year==undefined || year==''){
      year = new Date().getFullYear();
  }
  if(month==null ||  month==undefined || month==''){
      month = new Date().getMonth()+1;
  }
  day = new Date(new Date(year,month).setDate(0)).getDate();
  return year+"-"+month+"-"+day;
   
}
@CityDataFilterHoc
@connect((state) => state)
class StubIntact extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.fromParam = null;
    this.props.panelsInfo.openPanels.forEach((area) => {
      if (area.key == '030101')
      {
        if (area.param && area.param != null)
        {
          this.fromParam = area.param.paramInfo;
        }
      }
    });

    this.initCity = [];
    this.queryStubGroupId = "";
    if (this.fromParam && this.fromParam != null) {
      var cityIds = this.fromParam.cityIds
      ? this.fromParam.cityIds.split(',')
      : [];
      var provinceIds = this.fromParam.provinceIds
      ? this.fromParam.provinceIds.split(',')
      : [];
      if (provinceIds.length > 0)
      {
        if (provinceIds[0] != '000000') {
          this.initCity.push(provinceIds[0]);
        }
      }
      if (cityIds.length > 0)
      {
        this.initCity.push(cityIds[0].substr(0, 2) + '0000');
        this.initCity.push(cityIds[0]);
        console.log('dde', this.initCity);
      }
    }


    this.internationalization = this.props.intl.messages.stubIntact;
    this.beginData = null; 
    this.endData = null;
    if (this.fromParam == null)
    {
      var be = new Date();
      be.setDate(1);
      this.beginData = moment(be).format("YYYY-MM-DD");
      console.log('开始时间1：' + this.beginData)
      this.endData = moment(new Date()).format("YYYY-MM-DD");
    } else {
      if (this.fromParam.timeType == 'pickMonth')
      {
        this.fromParam.date = this.fromParam.date.substr(0, 7);
      }
      var be = moment(this.fromParam.date).toDate();
      this.endData = (moment(this.fromParam.date)).format("YYYY-MM-DD");
      be.setDate(1)
      this.beginData = (moment(be)).format("YYYY-MM-DD");
      console.log('开始时间2：' + this.beginData)
    }
    this.monthName = (this.fromParam == null ? (moment(new Date()).months() + 1) : (moment(this.fromParam.date).months() + 1));
    this.state = {
      mode:'1',
      addDisabled:false,
      type: "",
      typeOption: [
        {
          // 运营类型细项 初始化option选项
          text: "全部",
          value: "",
        },
      ],
      timeType: this.fromParam == null ? "pickMonth" : this.fromParam.timeType, // 查询form表单 日期表单选择方式  pickMonth：年月选择； pickDate：年月日选择
      choosedData: this.fromParam == null ? moment(new Date()).subtract(0, "d").format("YYYY.MM") : this.fromParam.date, // 选择的日期，默认是当月
      table1Value: { children: "完好率", value: "2" }, // 电站Top10 排序内容初始化
      table1sort: { children: "从低到高", value: "1" }, // 电站Top10 排序方式初始化
      table2Value: { children: "完好率", value: "2" }, // 设备Top100 排序内容初始化
      table2sort: { children: "从低到高", value: "1" }, // 设备Top100 排序方式初始化
      param: {
        // 传递子组件查询参数
        cityId: this.initCity.length == 0 ? "" : this.initCity[this.initCity.length - 1], // 地区
        type: this.fromParam == null ? "" : this.fromParam.stubType, // 设备类型
        operationProperty: '3', // 运营类型-运维/运营
        operationMode: this.fromParam == null ? "" : this.fromParam.operationMode, // 运营类型细项
        date: this.fromParam == null ? moment(new Date()).subtract(0, "d").format("YYYY-MM") : this.fromParam.date, // 时间->默认当月
      },
      table1SortParam: {
        // 电站Top10排序方式设置
        sortKey: "2", // 2：完好率。1：离线率：0：故障率
        sortFun: "1", // 1：由低到高。-1：由高到低
      },
      table2SortParam: {
        // 设备Top100排序方式设置
        sortKey: "2", // 2：完好率。1：离线率：0：故障率
        sortFun: "1", // 1：由低到高。-1：由高到低
      },
    };
  }

  // 电站top10设置ref
  formRef = React.createRef();

  // 设备top100设置ref
  formRef2 = React.createRef();

  /**
   * 初始化form查询表单
   */
  componentWillMount() {
    this.setState({
      formConfig: this.initFormConfig(),
    });
  }

  componentDidMount() {
    console.log(this.refs.select1);
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  

  /**
   * 初始化form查询表单数据
   */
  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "areaPicker",
          isPickArea: !0,
          placeholder: this.internationalization.placeholder2, // '请选择地区',
          pickOnSelect: true,
          param: {
            name: "cityId", // 与form表单绑定的参数名
            type: "array",
          },
          required: !1,
          labelName: "地区:",
          className: "allshow",
          sourceApi: getCityList,
          defaultValue:this.initCity.length == 0 ? [] : this.initCity,
          mapKey: {
            label: "label",
            value: "value",
            children: "children",
          },
        }, {
          type: "select",
          placeholder: "请选择", // '请选择设备状态',
          labelName: "运营类型", // '设备状态',
          param: {
            name: "operationMode",
            type: "string",
          },
          defaultValue:this.fromParam == null ? '' : this.fromParam.operationMode,
          options: [
            {
              text: "全部",
              value: "",
            },
            {
              text: "非直营",
              value: "0",
            },
            {
              text: "直营",
              value: "1",
            }],
          required: false,
        },
        {
          type: "select",
          options: [
            {
              text: this.internationalization.type0, // '全部',
              value: "",
            },
            {
              text: "交流电",
              value: "0",
            },
            {
              text: "直流电",
              value: "1",
            },
            {
              text: "交直流",
              value: "2",
            },
          ],
          placeholder: "请选择设备类型",
          param: {
            name: "type",
            type: "string",
          },
          labelName: this.internationalization.title4, // '设备类型:',
          required: false,
          defaultValue:this.fromParam == null ? '' : this.fromParam.stubType,
        },
        {
          type: "inputGroup",
          isArray: true,
          inputGroup: [
            {
              type: "select",
              options: [
                {
                  text: "月",
                  value: "1",
                },
                {
                  text: "日",
                  value: "0",
                },
              ],
              width: "80px",
              // placeholder: ['请选择',],
              param: {
                name: "searchType",
                type: "string",
              },
              onChange: (value, form) => {
                // 日期类型选择后执行，设置日期选择样式
                form.setFieldsValue({
                  searchType: value,
                });
                if (value === "0") {
                  this.setState(
                    {
                      timeType: "pickDate",
                    },
                    () => {
                      this.setState({
                        formConfig: this.initFormConfig(),
                      });
                    },
                  );
                } else if (value === "1") {
                  this.setState(
                    {
                      timeType: "pickMonth",
                    },
                    () => {
                      this.setState({
                        formConfig: this.initFormConfig(),
                      });
                    },
                  );
                }
              },
              allowClear: false,
              defaultValue: this.fromParam == null ? '1' : (this.fromParam.timeType == 'pickDate' ? "0":"1"),
              labelName: "日期:",
              required: false,
            },
            {
              type: "date",
              dateType: this.state.timeType,
              width: "140px",
              allowClear: false,
              // placeholder: ['请选择',],
              param: {
                name: "date",
                type: "object",
              },
              disabledDate: (current) => {
                let flag = false;
                if (current < moment(new Date("2020-01-01")).endOf("day")) {
                  flag = true;
                }

                if (current && current > moment(new Date()).endOf("day")) {
                  flag = true;
                }
                return flag;
              },
              defaultValue:
              this.fromParam == null ? (this.state.timeType === "pickMonth"
              ? moment(new Date()).subtract(0, "m")
              : moment(new Date()).subtract(0, "d")) : moment(this.fromParam.date).subtract(0, "d"),
              required: false,
            },
          ],
        },

        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "button",
              // icon: 'search',
              text: this.internationalization.btn1, // '查询',
              handler: (e, param) => {
                /**
                 * flag - > 判断data参数是否是monent类型
                 * cityId -> 格式化cityId
                 */
                // let flag = moment.isMoment(param.date);
                const cityId = param.cityId === undefined
                  ? ""
                  : param.cityId
                    .toString()
                    .slice(param.cityId.toString().lastIndexOf(",") + 1, param.cityId.toString().length);

                /**
                 * 设置参数，将电站top10排序方式，和设备TOP100排序方式 初始化
                 */
                let dateSet = '';
                if (param.searchType === "1") {
                  if (param.date) {
                    dateSet = param.date.format("YYYY-MM");
                  } else {
                    dateSet = moment(new Date()).format("YYYY-MM");
                  }
                  var be = moment(param.date).toDate();
                  if (be.getMonth() == (new Date()).getMonth())
                  {
                    this.endData = (moment(new Date())).format("YYYY-MM-DD");
                  } else {
                    this.endData = getMonthFinalDay(moment(param.date).years(),moment(param.date).months() + 1);
                  }
                  be.setDate(1)
                  this.beginData = (moment(be)).format("YYYY-MM-DD");
                  console.log('开始时间3：' + this.beginData)
                } else {
                  if (param.date) {
                    dateSet = param.date.format("YYYY-MM-DD");
                  } else {
                    dateSet = moment(new Date()).format("YYYY-MM-DD");
                  }
                  var be = moment(param.date).toDate();
                  be.setDate(1)
                  this.beginData = (moment(be)).format("YYYY-MM-DD");
                  console.log('开始时间4：' + this.beginData)
                  this.endData = (moment(param.date)).format("YYYY-MM-DD");
                }
                this.monthName = (moment(param.date).months() + 1);
                this.setState({
                  param: {
                    cityId: cityId,
                    type: param.type ? param.type : "",
                    operationProperty: "3",
                    operationMode: param.operationMode ? param.operationMode : "",
                    date: dateSet,
                  },
                  choosedData:
                    param.searchType === "1" ? param.date.format("YYYY.MM") : moment(param.date).format("YYYY.MM.DD"),
                  table1SortParam: {
                    sortKey: "2",
                    sortFun: "1",
                  },
                  table2SortParam: {
                    sortKey: "2",
                    sortFun: "1",
                  },
                  table1Value: { children: "完好率", value: "2" },
                  table1sort: { children: "从低到高", value: "1" },
                  table2Value: { children: "完好率", value: "2" },
                  table2sort: { children: "从低到高", value: "1" },
                });

                // 重置 电站top10\设备Top100 排序方式
                if (this.formRef && this.formRef != null && this.formRef.current != null)
                {
                  this.formRef.current.setFieldsValue({
                    top100Slect1: "2",
                    top100Slect2: "1",
                  });
                }

                if (this.formRef2 && this.formRef2 != null && this.formRef2.current != null)
                {
                  this.formRef2.current.setFieldsValue({
                    top10Slect1: "2",
                    top10Slect2: "1",
                  });
                }
                
                
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "stubIntactTable",
    };
    return formConfig;
  };

  /**
   *
   * tableKey：设置的健值名称
   * sortValue：设置的值
   */
  changeTableSort = (tableKey, sortValue) => {
    this.setState(
      {
        [tableKey]: sortValue, // {text:sortValue.props.children,value:sortValue.props.value},
      },
      () => {
        // 如果是 电站Top10 的相关设置，更改top10的排序方式
        if (tableKey === "table1Value" || tableKey === "table1sort") {
          this.setState({
            table1SortParam: {
              sortKey: this.state.table1Value.value,
              sortFun: this.state.table1sort.value,
            },
          });
        }

        // 如果是 设备Top100  的相关设置，更改top100的排序方式
        if (tableKey === "table2sort" || tableKey === "table2Value") {
          this.setState({
            table2SortParam: {
              sortKey: this.state.table2Value.value,
              sortFun: this.state.table2sort.value,
            },
          });
        }
      },
    );
  };

  /**
   * 选择按月呈现中的数据项后，传递执行
   */
  changeMonth = (value) => {
    this.monthName = (moment(value).months() + 1)
    var be = moment(value);
    be.days(1)
    this.beginData = (be).format("YYYY-MM-DD");
    console.log('开始时间5：' + this.beginData)
    this.endData = (moment(value)).format("YYYY-MM-DD");
    // 设置参数，初始化排序方式
    this.setState(
      {
        param: {
          cityId: this.state.param.cityId,
          operationProperty: "3",
          operationMode: this.state.param.operationMode,
          date: moment(value).format("YYYY-MM"),
          type: this.state.param.type,
        },
        table1SortParam: {
          sortKey: "2",
          sortFun: "1",
        },
        table2SortParam: {
          sortKey: "2",
          sortFun: "1",
        },
        choosedData: moment(value).format("YYYY.MM"),
      },
      () => {
        // 初始化排序方式
        this.formRef.current.setFieldsValue({
          top100Slect1: "2",
          top100Slect2: "1",
        });
        this.formRef2.current.setFieldsValue({
          top10Slect1: "2",
          top10Slect2: "1",
        });
      },
    );
  };
// 秒转换
  handleSecord(value) {
    const day = Math.floor(value / (24 * 3600)); // Math.floor()向下取整
    const hour = Math.floor((value - day * 24 * 3600) / 3600);
    const minute = Math.floor((value - day * 24 * 3600 - hour * 3600) / 60);
    const second = value - day * 24 * 3600 - hour * 3600 - minute * 60;
    if (day > 0) {
      return `${day}天${hour}时${minute}分`; // + second + "秒";
    } else if (hour > 0) {
      return `${hour}时${minute}分`; // + second + "秒";
    } else if (minute > 0) {
      return `${minute}分`; // + second + "秒";
    } else {
      return `${second}秒`;
    }
  }
  handleModeChange = (e) => {
    const mode = e.target.value;
    this.setState({ mode });
  }

  handleClickDevice = () => {
    var data = [];
    if (window.sessionStorage.getItem('top100Device') != null)
    {
      data = JSON.parse((window.sessionStorage.getItem('top100Device')));
      if (data.length == 0)
      {
        message.error("暂无数据");
        return;
      }
    } else {
      message.error("暂无数据");
      return;
    }
    var option={};
    let dataTable = [];
    if (data) {
      for (let i in data) {
        let obj = {}
        obj['排名'] = data[i]['serial'];
        obj['设备编号'] = data[i]['stubId'];
        obj['所属电站'] = data[i]['stubGroupName'];
        if (data[i].areaName === "--" || data[i].cityName === "--" || data[i].provinceName === "--") {
          obj['地区'] = "--";
        } else {
          obj['地区'] = data[i].provinceName + '-' + data[i].cityName + '-' +data[i].areaName;
        }
        if (data[i].operationMode == null) {
          obj['运营类型'] = "--";
        } else if (data[i].operationMode == 1) {
          obj['运营类型'] = "直营";
        } else if (data[i].operationMode == 0) {
          obj['运营类型'] = "非直营";
        }
        if (data[i].type == null) {
          obj['设备类型'] = "--";
        } else if (data[i].type == 1) {
          obj['设备类型'] = "直流电";
        } else if (data[i].type == 0) {
          obj['设备类型'] = "交流电";
        } else if (data[i].type == 2) {
          obj['设备类型'] = "交直流";
        }
        if (data[i].totalAvailableDuration !== "--") {
          obj['可用时长'] = this.handleSecord(parseInt(data[i].totalAvailableDuration));
        } else {
          obj['可用时长'] = "--";
        }
        if (data[i].totalOperationDuration !== "--") {
          obj['运营时长'] = this.handleSecord(parseInt(data[i].totalOperationDuration));
        } else {
          obj['运营时长'] = "--";
        }
        obj['可用率'] = data[i]['availableRate'] + '%';
        if (data[i].totalErrorDuration !== "--") {
          obj['故障时长'] = this.handleSecord(parseInt(data[i].totalErrorDuration));
        } else {
          obj['故障时长'] = "--";
        }
        obj['故障率'] = data[i]['errorRate'] + '%';
        if (data[i].totalOfflineDuration !== "--") {
          obj['离线时长'] = this.handleSecord(parseInt(data[i].totalOfflineDuration));
        } else {
          obj['离线时长'] = "--";
        }
        obj['离线率'] = data[i]['offlineRate'] + '%';
        if (data[i].totalOperationDuration !== "--" && data[i].totalErrorDuration !== "--" && data[i].totalOfflineDuration !== "--") {
          obj['完好时长'] = this.handleSecord(parseInt(data[i].totalOperationDuration) - parseInt(data[i].totalErrorDuration) - parseInt(data[i].totalOfflineDuration));
        } else {
          obj['完好时长'] = "--";
        }
        obj['完好率'] = data[i]['intactRate'] + '%';
        dataTable.push(obj);
      }
    }
    var header = ['排名', '设备编号', '所属电站', '地区', '运营类型', '设备类型', '可用时长', '运营时长', '可用率', '故障时长', '故障率', '离线时长', '离线率', '完好时长', '完好率'];
    option.fileName = this.beginData + '至' + this.endData + '设备'
    option.datas=[
      {
        sheetData:dataTable,
        sheetName:'sheet',
        sheetFilter:header,
        sheetHeader:header,
      }
    ];

    var toExcel = new ExportJsonExcel(option); 
    toExcel.saveExcel(); 
  };

  handleClick = () => {
    var data = [];
    if (window.sessionStorage.getItem('top10Station') != null)
    {
      data = JSON.parse((window.sessionStorage.getItem('top10Station')));
      if (data.length == 0)
      {
        message.error("暂无数据");
        return;
      }
    } else {
      message.error("暂无数据");
      return;
    }
    var option={};
    let dataTable = [];
    if (data) {
      for (let i in data) {
        let obj = {}
        obj['排名'] = data[i]['serial'];
        obj['电站'] = data[i]['stubGroupName'];
        obj['设备总数'] = data[i]['stubCnt'];
        if (data[i].areaName === "--" || data[i].cityName === "--" || data[i].provinceName === "--") {
          obj['地区'] = "--";
        } else {
          obj['地区'] = data[i].provinceName + '-' + data[i].cityName + '-' +data[i].areaName;
        }
        if (data[i].availableCnt !== "--" && data[i].availableCnt !== 0) {
          obj['平均可用时长'] = this.handleSecord(parseInt(data[i].totalAvailableDuration / data[i].availableCnt));
        } else {
          obj['平均可用时长'] = "--";
        }
        if (data[i].stubCnt !== "--" && data[i].stubCnt !== 0) {
          obj['平均运营时长'] = this.handleSecord(parseInt(data[i].totalOperationDuration / data[i].stubCnt));
        } else {
          obj['平均运营时长'] = "--";
        }
        obj['可用率'] = data[i]['availableRate'] + '%';
        if (data[i].stubCnt !== "--" && data[i].stubCnt !== 0) {
          obj['平均故障时长'] = this.handleSecord(parseInt(data[i].totalErrorDuration / data[i].stubCnt));
        } else {
          obj['平均故障时长'] = "--";
        }
        obj['故障率'] = data[i]['errorRate'] + '%';
        if (data[i].stubCnt !== "--" && data[i].stubCnt !== 0) {
          obj['平均离线时长'] = this.handleSecord(parseInt(data[i].totalOfflineDuration / data[i].stubCnt));
        } else {
          obj['平均离线时长'] = "--";
        }
        obj['离线率'] = data[i]['offlineRate'] + '%';
        if (data[i].stubCnt !== "--" && data[i].stubCnt !== 0) {
          const allAvg = parseInt(data[i].totalOperationDuration / data[i].stubCnt);
          const errAvg = parseInt(data[i].totalErrorDuration / data[i].stubCnt);
          const offLineAvg = parseInt(data[i].totalOfflineDuration / data[i].stubCnt);
          const intactAvg = this.handleSecord(allAvg - errAvg - offLineAvg);
          obj['平均完好时长'] = this.handleSecord(allAvg - errAvg - offLineAvg);
        } else {
          obj['平均完好时长'] = "--";
        }
        obj['完好率'] = data[i]['intactRate'] + '%';
        dataTable.push(obj);
      }
    }
    var header = ['排名', '电站', '设备总数', '地区', '平均可用时长', '平均运营时长', '可用率', '平均故障时长', '故障率', '平均离线时长', '离线率', '平均完好时长', '完好率'];
    option.fileName = this.beginData + '至' + this.endData + '电站'
    option.datas=[
      {
        sheetData:dataTable,
        sheetName:'sheet',
        sheetFilter:header,
        sheetHeader:header,
      }
    ];

    var toExcel = new ExportJsonExcel(option); 
    toExcel.saveExcel(); 
  };

  /**
   * 选择按日呈现中的数据项后，传递执行
   */
  changeDay = (value) => {
    return;
    // 设置参数，初始化排序方式
    this.monthName = (moment(value).months() + 1)
    var be = moment(value);
    be.days(1)
    this.beginData = (be).format("YYYY-MM-DD");
    console.log('开始时间6：' + this.beginData)
    this.endData = (moment(value)).format("YYYY-MM-DD");
    this.setState(
      {
        param: {
          cityId: this.state.param.cityId,
          operationProperty: "3",
          operationMode: this.state.param.operationMode,
          date: moment(value).format("YYYY-MM-DD"),
          type: this.state.param.type,
        },
        table1SortParam: {
          sortKey: "2",
          sortFun: "1",
        },
        table2SortParam: {
          sortKey: "2",
          sortFun: "1",
        },
        choosedData: moment(value).format("YYYY.MM.DD"),
      },
      () => {
        // 初始化排序方式
        this.formRef.current.setFieldsValue({
          top100Slect1: "2",
          top100Slect2: "1",
        });
        this.formRef2.current.setFieldsValue({
          top10Slect1: "2",
          top10Slect2: "1",
        });
      },
    );
  };

  render() {
    const { mode } = this.state;

    // 排序方式
    const sortTypeOption = [
      { label: "完好率", value: "2" },
      { label: "故障率", value: "0" },
      { label: "离线率", value: "1" },
      // {label:'可用率',value:'3'}
    ];
    const sortFuncOption = [
      { label: "从低到高", value: "1" },
      { label: "从高到低", value: "-1" },
    ];
    const val = (
      <div className='analysis' ref='stubIntact' style={{ height: "100%", overflowY: "auto" }}>
        <Affix target={() => this.refs.stubIntact}>
          <div className='analysis-title stub-intact-rate-page'>
            <FormCore formConfig={this.state.formConfig} />
          </div>
        </Affix>
        {
        // false ? (
        //   <div></div>
        // ) : (
        //   <div>
        //     <div className='analysis-item' style={{ borderRadius: "6px" }}>
        //       <div className='analysis-item-title analysis-title-font'>按月呈现:</div>
        //     </div>

        //     <div><StubDate params={this.state} onAdd={this.props.onAdd}></StubDate></div>
        //   </div>
        // )
        }
        {/* <div className='analysis-item'>
          <div className='analysis-item-title analysis-title-font'>按月呈现:</div>
        </div>
        <div>
          <StubMonth param={this.state.param} changeMonth={this.changeMonth} />
        </div> */}

        <div className='analysis-item'>
          <div className='analysis-item-title analysis-title-font'>{this.monthName}月设备运行情况:</div>
        </div>
        <StubDay param={this.state.param} changeDay={this.changeDay} />

         <div className='analysis-item hasSelect'>
          <div className='analysis-item-title analysis-title-font'>


          <Radio.Group onChange={this.handleModeChange} value={mode} style={{ margin: "0 10px"}}>
          <Radio.Button value="1">场站完好率</Radio.Button>
          <Radio.Button value="2">设备完好率</Radio.Button>
        </Radio.Group>
          <span>{this.beginData}至{this.endData}</span>
            {/* {(mode == 1) ? 
            <Tooltip title='可点击上方折线图的日期，展示选中日期对应的场站数据,默认排序是按照可用率从高到低进行排列'>
              {" "}
              <QuestionCircleOutlined style={{ margin: "0 10px", color: "#999" }} />
            </Tooltip>
            
            :
            <Tooltip title='可点击上方折线图的日期，展示选中日期对应的设备数据,默认排序是按照可用率从高到低进行排列'>
              {" "}
              <QuestionCircleOutlined style={{ margin: "0 10px", color: "#999" }} />
            </Tooltip>} */}
            {/* {this.state.choosedData}设备使用率{" "} */}
            {(mode == 1) ? 
            <Button
              onClick={this.handleClick}
              type="primary"
              disabled={this.state.addDisabled}
              style={{ margin: "5px" }}>
              导出
            </Button>
              :
            <Button
              onClick={this.handleClickDevice}
              type="primary"
              disabled={this.state.addDisabled}
              style={{ margin: "5px" }}>
              导出
            </Button>
  }
          </div>
          {(mode == 1) ?
          <div className='paixu'>
            排序方式：
            <Form ref={this.formRef2}>
              <FormItem name='top10Slect1' initialValue="2">
                <Select
                  placeholder='请选择'
                  onSelect={(value, option) => {
                    this.changeTableSort("table1Value", option);
                  }}
                  style={{ width: 90, marginRight: 10, fontSize: 12 }}>
                  {sortTypeOption.map((item) => {
                    return (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    );
                  })}
                </Select>
              </FormItem>
              <FormItem name='top10Slect2' initialValue="1">
                <Select
                  placeholder='请选择'
                  onSelect={(value, option) => {
                    this.changeTableSort("table1sort", option);
                  }}
                  style={{ width: 90, fontSize: 12 }}>
                  {sortFuncOption.map((item) => {
                    return (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    );
                  })}
                </Select>
              </FormItem>
            </Form>
          </div>



          :
          <div className='paixu'>
            排序方式：
            <Form ref={this.formRef}>
              <FormItem name='top100Slect1' initialValue="2">
                <Select
                  ref='select2'
                  placeholder='请选择'
                  onSelect={(value, option) => {
                    this.changeTableSort("table2Value", option);
                  }}
                  style={{ width: 90, marginRight: 10, fontSize: 12 }}>
                  {sortTypeOption.map((item) => {
                    return (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    );
                  })}
                </Select>
              </FormItem>

              <FormItem name='top100Slect2' initialValue="1">
                <Select
                  placeholder='请选择'
                  onSelect={(value, option) => {
                    this.changeTableSort("table2sort", option);
                  }}
                  style={{ width: 90, fontSize: 12 }}>
                  {sortFuncOption.map((item) => {
                    return (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    );
                  })}
                </Select>
              </FormItem>
            </Form>
          </div>}
        </div>
        {(mode == 1) ? 
        <StationIntactTop10
          param={this.state.param}
          sort={this.state.table1SortParam}
          onAdd={this.props.onAdd} />
        :
        
        <StubIntactTop100
          param={this.state.param}
          sort={this.state.table2SortParam}
          onAdd={this.props.onAdd} />}

        <div>{/* <StubType params={this.state} onAdd={this.props.onAdd}></StubType> */}</div>
      </div>
    );

    return val;
  }
}

export default injectIntl(StubIntact);



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/stubIntactRate/stubIntact.js